import {createSlice} from "@reduxjs/toolkit"

const initialState = {
    user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null,
    loading: false,
    permissions: localStorage.getItem("permissions")
    ? JSON.parse(localStorage.getItem("permissions"))
    : [],
};

const ProfileSlice = createSlice({
    name:"profile",
    initialState: initialState,
    reducers: {
        setUser(state, value) {
            state.user = value.payload;
        },
        setLoading(state, value) {
            state.loading = value.payload;
          },
          setPermissions(state, action) {
    state.permissions = action.payload;
  },
    },
});

export const {setUser, setLoading,setPermissions } = ProfileSlice.actions;
export default ProfileSlice.reducer;